import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { Header } from "@/components/Header";
import { WhatsAppTopBar } from "@/components/WhatsAppTopBar";
import { Footer } from "@/components/Footer";
import { BackToTop } from "@/components/BackToTop";
import { SocialFloat } from "@/components/SocialFloat";
import { TelegramBanner, TelegramFloat } from "@/components/TelegramJoin";

export function PublicLayout() {
  return (
    <div className="App flex min-h-screen flex-col">
      <WhatsAppTopBar />
      <Header />
      <TelegramBanner />
      <main className="flex-1 pb-6">
        <Suspense fallback={<div className="min-h-[60vh]" />}><Outlet /></Suspense>
      </main>
      <Footer />
      <SocialFloat />
      <TelegramFloat />
      <BackToTop />
    </div>
  );
}
